module.exports = __webpack_public_path__ + "img/Group 10.96ef5e10.svg";